import React from "react";
import FrequentAskQuestion from "../components/FrequentAskQuestion";

function Faq() {
    return (
        <FrequentAskQuestion />
    )
}
export default Faq;